import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { useEffect, useState } from 'react';
import styles from './LanguageSwitcher.module.scss';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const [currentLang, setCurrentLang] = useState(i18n.language || 'en');
  const isMobile = window.innerWidth <= 768;

  useEffect(() => {
    // Set initial language if not set
    if (!i18n.language) {
      i18n.changeLanguage('en');
    }
    // Update state when language changes
    setCurrentLang(i18n.language);
  }, [i18n.language]);

  const toggleLanguage = () => {
    const newLang = currentLang === 'en' ? 'fr' : 'en';
    i18n.changeLanguage(newLang);
    setCurrentLang(newLang);
  };

  return (
    <motion.div 
      className={styles.languageSwitcherContainer}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.3 }}
    >
      <div className={styles.languageWrapper}>
        <button 
          className={`${styles.languageButton} ${currentLang === 'en' ? styles.active : ''}`}
          onClick={() => currentLang !== 'en' && toggleLanguage()}
          aria-label="Switch to English"
        >
          EN
        </button>
        <span className={styles.separator}>{isMobile ? '—' : '/'}</span>
        <button 
          className={`${styles.languageButton} ${currentLang === 'fr' ? styles.active : ''}`}
          onClick={() => currentLang !== 'fr' && toggleLanguage()}
          aria-label="Switch to French"
        >
          FR
        </button>
      </div>
    </motion.div>
  );
};

export default LanguageSwitcher;